export const PlaybackEventNames = {
    started: "Video Playback Started",
    paused: "Video Playback Paused",
    interrupted: "Video Playback Interrupted",
    bufferStarted: "Video Playback Buffer Started",
    bufferCompleted: "Video Playback Buffer Completed",
    seekStarted: "Video Playback Seek Started",
    seekCompleted: "Video Playback Seek Completed",
    resumed: "Video Playback Resumed",
    completed: "Video Playback Completed",
    exited: "Video Playback Exited",
};
//# sourceMappingURL=PlaybackEvents.js.map